import { useEffect } from "react";
import { AppState } from "@-/com.npmjs.react-native";
import type { ActorRawDatabaseHandle } from "@-/dev.improve.haniverse.database.actor";
import { maintainActorBackups } from "#actor-backups";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";

export function useActorBackups(
  getDatabase: () => ActorRawDatabaseHandle | null,
  ready: boolean,
): void {
  const [enabled] = useDeviceSetting("isLocalBackupEnabled");
  useEffect(() => {
    const run = () => {
      if (ready && AppState.currentState === "active") {
        void maintainActorBackups(getDatabase()).catch(() => {});
      }
    };
    const initial = setTimeout(run, 15_000);
    const interval = setInterval(run, 60_000);
    const subscription = AppState.addEventListener("change", (state) => {
      if (state === "active") {
        run();
      }
    });
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
      subscription.remove();
    };
  }, [enabled, getDatabase, ready]);
}
